import { useState } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../../common/DeleteModal";
import { Translate } from "../../../../Enums/Tranlate";
import OrganizationService from "../../../../../services/HRM/OrganizationService";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const navigate = useNavigate();
	const organizationService = new OrganizationService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.name || "-"}</td>
			<td>
				<div className="d-flex flex-wrap gap-1">
					{item?.additionalNames?.length
						? item.additionalNames.map((an) => (
								<Badge key={an.id} variant="secondary">
									{an.name}
								</Badge>
							))
						: "-"}
				</div>
			</td>
			<td>{item?.createdAt?.split("T")[0] || "-"}</td>
			<td>
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-h" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item
							onClick={() =>
								navigate("/organization/edit-organization", { state: item })
							}>
							<i className="la la-edit"></i> {Translate[lang]?.edit}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							<i className="la la-trash"></i> {Translate[lang]?.delete}
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={organizationService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};

export default CardItem;
